const nameData = "pedidos"; // Define la entidad dinámica
const nameDataSingular = "pedido"; // Para el caso singular

export const fetchEntityData = async (getEntityPanelData, searchCli,searchEmp,dateFrom,dateUntil, numPagina, filas) => {
  try {
    const data = await getEntityPanelData(searchCli,searchEmp,dateFrom,dateUntil,numPagina, filas);
    if (data) {
      const totalPage = data.pagination.totalPage || 1;
      return {
        dataEntity: data[nameData] || [], // Usa nameData dinámicamente
        totalItems: data.pagination.totalItems || 0,
        totalPage,
      };
    }
  } catch (error) {
    console.error(`Error al cargar ${nameData}:`, error);
    throw error;
  }
};
